import { useLazyGetCarModelsQuery } from '@/api/carModels'
import FilterableSelect from '@/components/inputs/FilterableSelect/FilterableSelect'
import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'

type Props = {
  carBrand: number | undefined
  year: number | undefined
  selectedModel: number | undefined
  onSelectedModel: (value: number) => void
}

const CarModels = (props: Props) => {
  const [trigger, result] = useLazyGetCarModelsQuery()
  const { t } = useTranslation('shop')

  const onSelectedModel = (value: string | null) => {
    props.onSelectedModel(Number(value))
  }

  useEffect(() => {
    if (props.carBrand && props.year)
      trigger({ manufactureId: props.carBrand, year: props.year })
  }, [props.carBrand, props.year, trigger])

  const items = result.data?.map((model) => {
    return {
      name: `${model.name}`,
      subName: `${t('fromYear')} ${model.fromYear} - ${model.toYear || ''}`,
      value: model.id
    }
  })

  return (
    <FilterableSelect
      options={items || []}
      name="model"
      placeholder={t('carModel') || ''}
      value={props.selectedModel ? props.selectedModel.toString() : null}
      onChange={onSelectedModel}
      loading={result.isFetching}
      disabled={result.isFetching}
    />
  )
}

export default CarModels